export default __webpack_public_path__ + "static/media/kanit-medium.de109d32.ttf";